import { createFeatureSelector, createSelector } from '@ngrx/store'
import { IConcernedViewState} from './concerned-view.reducer'
import { StoreKeysEnum } from '../../../../store/store-keys'

export const selectConcernedViewFeature = createFeatureSelector<Readonly<IConcernedViewState>>(StoreKeysEnum.ConcernedView)

export const selectConcernedViewAllConcerned = createSelector(
    selectConcernedViewFeature,
    feature => (feature.allConcerned)
)
export const selectConcernedViewConcernedDetails = createSelector(
    selectConcernedViewFeature,
    feature => (feature.concernedDetails)
)